export default function Footer() {
  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-accent-500/10 border-t border-background-200/60">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-1/3">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-2-fill text-foreground-950 text-xl" />
              </span>
              <span className="font-heading text-xl tracking-widest text-foreground-950">
                工口<em className="not-italic text-primary-500">游鉴</em>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-7 max-w-md">
              专注工口游戏推荐、排行榜、神作盘点与口碑评测的内容站。从入门到进阶，帮你快速锁定对胃口的作品，少走弯路，玩得尽兴。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#hero" onClick={() => go("#hero")} className="w-9 h-9 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer" aria-label="X">
                <i className="ri-twitter-x-line" />
              </a>
              <a href="#hero" onClick={() => go("#hero")} className="w-9 h-9 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer" aria-label="Bilibili">
                <i className="ri-bilibili-line" />
              </a>
              <a href="#hero" onClick={() => go("#hero")} className="w-9 h-9 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line" />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 lg:flex-1">
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容导航</h4>
              <ul className="space-y-3">
                {[
                  { href: "#beginner", label: "入门推荐" },
                  { href: "#ranking", label: "排行榜" },
                  { href: "#masterpiece", label: "神作盘点" },
                ].map((item) => (
                  <li key={item.href}>
                    <button onClick={() => go(item.href)} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">更多内容</h4>
              <ul className="space-y-3">
                {[
                  { href: "#reviews", label: "口碑评测" },
                  { href: "#faq", label: "常见问题" },
                  { href: "#hero", label: "回到顶部" },
                ].map((item) => (
                  <li key={item.href}>
                    <button onClick={() => go(item.href)} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于本站</h4>
              <p className="text-sm text-foreground-600 leading-6">
                本网站仅提供游戏推荐与评测内容，请通过官方发行平台支持正版。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 工口游鉴 · 工口游戏推荐与评测站 · 请支持正版
          </p>
          <p className="text-xs text-foreground-500">内容仅供评测参考，请理性消费</p>
        </div>
      </div>
    </footer>
  );
}